import React from 'react'
import { Navbar } from 'react-bootstrap'

import './style.scss'

const Index = ({mobileMainMenuOpen, setMobileMainMenuOpen, mobileCompaniesMenuOpen, setMobileCompaniesMenuOpen}) => {

    const clickMenu = () => {
        setMobileCompaniesMenuOpen(false)
        setMobileMainMenuOpen(!mobileMainMenuOpen)
    }

    return(
        <div className="menu-dropdown-container">
            <Navbar className={`mobile-menu ${mobileMainMenuOpen ? 'open':''}`} collapseOnSelect expand="md">
                <Navbar.Toggle onClick={() => clickMenu()} className="menu-toggle" aria-controls="responsive-navbar-nav"><i class="fad fa-bars"></i></Navbar.Toggle>
            </Navbar>
        </div>
    )
}

export default Index